import React, { Fragment } from 'react';
import classNames from 'classnames';

import css from './OverlapSection.module.scss';

const OverlapSection = ({ heading, description, hasBackground }) => {
	return (
		<section
			className={
				hasBackground
					? classNames(css.overlapSection, css.hasBackground)
					: css.overlapSection
			}
		>
			<div className={css.contentWrapper}>
				<h2 className="animateOnlyMobile" data-aos="custom-fade-right">
					{heading}
				</h2>
				<p className="animateOnlyMobile" data-aos="custom-fade-right">
					{Array.isArray(description)
						? description.map((item, index) => (
								<Fragment key={index}>{item}</Fragment>
						  ))
						: description}
				</p>
			</div>
		</section>
	);
};

export default OverlapSection;
